export const DEFAULT_ROWS_PER_PAGE = 100;
export const FILE_UPLOAD_MAX_SIZE_MB = 20;

export const FILES_PAGE_ID = 'files';

export const DEFAULT_TABLE_PAGE = {
    totalElements: 1000,
    number: 1,
    size: 1000,
    totalPages: 1,
};
